var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, isValidElement } from 'react';
import * as S from './styles';
import { XCircle } from '@olxbr/ds-icons';
import { Text } from '../Text';
const RADIO_ACESSIBILITY_ERROR = 'Se o radio não possuir um label textual descritivo é necessário informar o atributo "aria-label"';
const RADIO_INVALID_LABEL_ERROR = 'A prop label precisa ser do tipo "ReactNode"';
const RadioLabel = ({ label, outline, checked }) => {
    if (!label)
        return null;
    if (typeof label === 'string') {
        return (React.createElement(S.Label, { marginLeft: "--spacing-1", color: "--color-neutral-130", outline: outline, checked: checked }, label));
    }
    if (isValidElement(label))
        return React.createElement(S.LabelWrapper, null, label);
    throw new Error(RADIO_INVALID_LABEL_ERROR);
};
export const Radio = forwardRef((props, ref) => {
    const { error, errorMessage, label, checked, disabled, display, 'aria-label': ariaLabel, margin, marginBottom, marginLeft, marginRight, marginTop, outline, icon } = props, restProps = __rest(props, ["error", "errorMessage", "label", "checked", "disabled", "display", 'aria-label', "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "outline", "icon"]);
    if (!label && !ariaLabel)
        throw new Error(RADIO_ACESSIBILITY_ERROR);
    return (React.createElement(S.Radio, { "data-ds-component": "DS-Radio", disabled: disabled, display: display, margin: margin, marginBottom: marginBottom, marginLeft: marginLeft, marginRight: marginRight, marginTop: marginTop, outline: outline, checked: checked, error: error },
        React.createElement(S.RadioContentWrapper, null,
            React.createElement(S.RadioContent, null,
                React.createElement(S.RadioInput, null,
                    React.createElement(S.RadioNativeInput, Object.assign({ "aria-label": ariaLabel, "aria-checked": checked ? 'true' : 'false', ref: ref, checked: checked, disabled: disabled, type: "radio" }, restProps)),
                    React.createElement(S.RadiotStylizedInput, { checked: checked, error: error })),
                icon && (React.createElement(S.RadioCustomIcon, { "aria-hidden": true, checked: checked }, icon)),
                React.createElement(RadioLabel, Object.assign({}, props))),
            label && errorMessage && (React.createElement(S.RadioErrorMessage, null,
                React.createElement(XCircle, { size: "16px" }),
                React.createElement(Text.Caption, { role: "alert", marginTop: "--spacing-0-25" }, errorMessage))))));
});
Radio.displayName = 'Radio';
